import { render, staticRenderFns } from "./toll-free-verification-dialog.vue?vue&type=template&id=47ab41f5&scoped=true"
import script from "./toll-free-verification-dialog.vue?vue&type=script&lang=js"
export * from "./toll-free-verification-dialog.vue?vue&type=script&lang=js"
import style0 from "./toll-free-verification-dialog.vue?vue&type=style&index=0&id=47ab41f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ab41f5",
  null
  
)

export default component.exports